import {cashBoxHeaderFilter} from "../../../hoc/cashBoxHeaderFilter";
import CashBoxTransferRegister from "./CashBoxTransferRegister";

const CashBoxTransferDataTableHeader = cashBoxHeaderFilter(CashBoxTransferRegister,"CashBoxTransferDataTableHeader")
export default CashBoxTransferDataTableHeader
